import React, { useState } from 'react';
// import Input from '../../../../components/Input/Input';
import Compressor from 'compressorjs';
import Dropzone, { DropzoneRenderArgs } from 'react-dropzone';
import Button from '../../../../components/Button/Button';
import { display } from '../../../../components/ErrorView/ErrorDialog';
import {
  default as Toast,
  default as notify,
} from '../../../../components/Notify';
import Select from '../../../../components/Select';
import { uriToBlob } from '../../../../utils/file';
import {
  CustomIcon,
  DocInputCont,
  Remove,
  SignatureThumbContainer,
  ThumbImage,
} from './styles';
import { IDocumentView } from 'store/companies/companiesTypes';
import i18n from '../../../../i18n';

interface IRoleInputProps {
  addDocument: (type: string, file: any) => Promise<any>;
  companyId: number;
}
// const ACCEPTED_TYPES = '*/*';
const MAX_SIZE = 10240000;

const DocumentInput: React.FC<IRoleInputProps> = ({ addDocument }) => {
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null as IDocumentView | null);

  const setDocument = (acceptedFile: File) => {
    const { name, size, type } = acceptedFile;
    const file: IDocumentView = {
      url: URL.createObjectURL(acceptedFile),
      fileSize: size,
      properties: {
        format: type.split('/')[1],
        displayName: name,
      },
    };
    setFile(file);
  };

  const handleAcceptedFiles = (files: DropzoneRenderArgs['acceptedFiles']) => {
    const acceptedFile = files[0];
    const { size } = acceptedFile;

    if (size > MAX_SIZE) {
      new Compressor(acceptedFile, {
        quality: MAX_SIZE / size,
        convertSize: MAX_SIZE,
        success: (result: any) => {
          if (result.size < MAX_SIZE) setFile(result);
          else
            notify(
              i18n.t('failedToCompressImage', { ns: 'companyManagement' }),
              'warning'
            );
        },
        error: () => {
          notify(
            i18n.t('failedToCompressImage', { ns: 'companyManagement' }),
            'warning'
          );
        },
      });
    } else setDocument(acceptedFile);
  };

  const handleRejectedFiles = (files: DropzoneRenderArgs['rejectedFiles']) => {
    const file = files[0];
    let warningMessage;
    if (file.size > MAX_SIZE) {
      warningMessage = i18n.t('sizeOfTheFileShouldBeLessThanTenMB', {
        ns: 'companyManagement',
      });
    } else {
      warningMessage = i18n.t('onlyImagesAreValid', {
        ns: 'companyManagement',
      });
    }
    Toast(warningMessage, 'warning');
  };

  return (
    <DocInputCont>
      <Select
        values={
          type
            ? [
                {
                  value: type,
                  label:
                    i18n.t(`${type}`, {
                      ns: 'companyManagement',
                    }) || type,
                },
              ]
            : []
        }
        onChangeValues={(e) => {
          setType(e[0]?.value?.toString());
        }}
        options={[
          {
            value: 'signatures',
            label: i18n.t('signatures', {
              ns: 'companyManagement',
            }),
          },
          {
            value: 'logo',
            label: i18n.t('logo', {
              ns: 'companyManagement',
            }),
          },
          {
            value: 'logo2',
            label: i18n.t('logo2', {
              ns: 'companyManagement',
            }),
          },
        ]}
        allowRemove={true}
        multiChoice={true}
        placeholder={i18n.t('docType', {
          ns: 'companyManagement',
        })}
        letAddChip={true}
      />
      {file ? (
        <SignatureThumbContainer>
          <a target="_blank" href={file!.url} rel="noopener noreferrer">
            <ThumbImage src={file!.url} />
          </a>
          {<Remove type="x" color="red" onClick={() => setFile(null)} />}
        </SignatureThumbContainer>
      ) : (
        <Dropzone
          style={{
            width: '50px',
            height: '50px',
            border: '1px solid black',
            borderRadius: '10px',
            cursor: 'pointer',
          }}
          // accept={ACCEPTED_TYPES}
          multiple={false}
          onDropRejected={handleRejectedFiles}
          onDropAccepted={handleAcceptedFiles}
        >
          {/* @ts-expect-error JSX error*/}
          {() => (
            <div>
              <CustomIcon type="plus" />
            </div>
          )}
        </Dropzone>
      )}
      <Button
        loading={loading}
        disabled={!file || !type}
        onClick={async () => {
          setLoading(true);
          addDocument(type, await uriToBlob(file!.url)).then(
            () => {
              setLoading(false);
              setFile(null);
              setType('');
            },
            (error) => {
              display(error);
              setLoading(false);
            }
          );
        }}
      >
        {i18n.t('save', { ns: 'companyManagement' }) as string}
      </Button>
    </DocInputCont>
  );
};

export default DocumentInput;
